<template>
  <div class="products-ywym-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction">
      <!-- <template #left>
        <div class="text-left w-50% self-center">
          <p class="text-[#616671] text-[1rem] mb-[3rem] w-32.5rem"
            v-for="desc in content.businessIntroduction.description">{{
              desc }}</p>

          <div class="flex justify-between text-center w-32.5rem">
            <div class="flex flex-col text" v-for="extraDesc in content.businessIntroduction.extraDesData">
              <span class="text-1.63rem text-#272E3B mb-0.5rem font-800">{{ extraDesc.title }}</span>
              <span class="text-#616671 text-1.1rem">{{ extraDesc.desc }}</span>
            </div>
          </div>
        </div>
      </template> -->
    </PageBusinessCol>

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { shallowReactive } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '物码关联'
const description = '一物一码，实时追溯源头，轻松辨别真伪'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/ywym/banner.png',
    mobileBanner: '/images/mobile/products/ywym.png'
  },
  businessIntroduction: {
    title: '业务介绍',
    description: [
      '物码关联数字化溯源系统以“一物一码”为核心，通过串联产线、产品、条码数据，实现“物-码-数据”的精准关联与物码一致性管理，现阶段系统聚焦服务品牌商的生码需求与产线打包采集以及数据分析统计场景，未来将进一步延伸至渠道流通领域，并基于带码产品开发多元化应用场景。',
    ],
    descImage: '/images/pages/products/ywym/c- (1).png'
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#EFF8FF',
    extraTitleClass: 'bg-#EFF8FF w-100%!',
    groups: [
      {
        title: '档案',
        desc: '',
        descList: [
          '自主定义业务数据，为上层应用提供可靠的基础支撑',
        ],
        icon: '/images/pages/products/ywym/f-i- (4).png',
        mainImage: '/images/pages/products/ywym/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '产码',
        desc: '',
        descList: ['批量生成加密唯一码，防篡改、防重复，保障码值安全合规',],
        icon: '/images/pages/products/ywym/f-i- (3).png',
        mainImage: '/images/pages/products/ywym/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '生产',
        desc: '',
        descList: ['实时采集生产数据，动态监控各业务各产线的生产进度'],
        icon: '/images/pages/products/ywym/f-i- (1).png',
        mainImage: '/images/pages/products/ywym/f- (4).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '报表',
        desc: '',
        descList: ['汇总全流程数据，生成多维度可视化报表，直观呈现业务核心指标',],
        icon: '/images/pages/products/ywym/f-i- (2).png',
        mainImage: '/images/pages/products/ywym/f- (3).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    background: '/images/pages/products/ywym/b-back.png',
    list: [
      {
        briefBack: '/images/pages/products/ywym/b- (1).png',
      },
      {
        briefBack: '/images/pages/products/ywym/b- (2).png',
      },
      {
        briefBack: '/images/pages/products/ywym/b- (3-0).png',
      },
      {
        briefBack: '/images/pages/products/ywym/b-5.png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-ywym-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .ywym-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/ywym/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/ywym/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.ywym-product-advantage {
  background-image: url("/images/pages/products/ywym/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
